module.exports = __webpack_public_path__ + "img/png.a43a7643.svg";